export default __webpack_public_path__ + "static/media/ic-art-routine-tracking.2552f414.svg";